<template>
  <div v-if="mode === 'accordion'" class="accordion-body">
    <ListMessageTemplate
      :all-templates="allMessageTemplates"
      :isDragDisabled="isDragModalDisabled"
      :disable-columns="[0, 4, 'create']"
      @rowSelected="rowSelected"
    >
    </ListMessageTemplate>
  </div>

  <b-modal
    v-else
    id="mailTemplateModal"
    size="lg"
    scrollable
    ref="modal"
    @hidden="hideModal"
    title=""
    header-class="header"
    body-class="body"
    footer-class="footer"
  >
    <template #modal-header="{close}">
      <div class="d-flex justify-content-between w-100 pe-2">
        <button
          type="button"
          aria-label="Close"
          class="close p-2"
          @click="close()"
        >
          ×
        </button>
      </div>
    </template>

    <ListMessageTemplate
      :all-templates="allMessageTemplates"
      :isDragDisabled="isDragModalDisabled"
      :disable-columns="[0, 4, 'create']"
      @rowSelected="rowSelected"
    >
      <template v-slot:messageTemplate>
        <router-link
          to="/message-template"
          class="btn btn-primary template-button"
          target="_blank"
        >
          テンプレート 編集
        </router-link>
      </template>
    </ListMessageTemplate>

    <template #modal-footer>
      <div></div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import ListMessageTemplate from './ListMessageTemplate.vue';

export default {
  name: 'MailTemplateModal',
  components: { ListMessageTemplate },
  props: {
    mode: {
      type: String,
      default: 'modal', // 'modal' or 'accordion'
    },
  },
  data() {
    return {
      allMessageTemplates: undefined,
      isDragModalDisabled: true,
    };
  },
  methods: {
    ...mapActions(['getOrLoadMessageTemplates']),
    hideModal() {
      this.$emit('hide-modal');
    },
    rowSelected(id) {
      this.$emit('rowSelected', id);
    },
  },
  mounted() {
    if (this.mode === 'modal') {
      this.$refs.modal.show();
    }
  },
  async created() {
    this.allMessageTemplates = await this.getOrLoadMessageTemplates();
  },
};
</script>

<style scoped>
.template-button {
  float: right;
  padding: 8px;
  width: 250px;
  text-align: center;
  margin-bottom: 5px;
  border-radius: 5px;
}
</style>
